export default "__VITE_ASSET__D7bn6lRt__"